import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import './mockups.css';

const NAV = [
  { to: '/mockups',                label: 'Overview' },
  { to: '/mockups/dashboard',      label: 'Member Dashboard' },
  { to: '/mockups/global-pif',     label: 'Global PIF List' },
  { to: '/mockups/personal-pif',   label: 'Personal PIF Queue' },
  { to: '/mockups/link-file',      label: 'Link File' },
  { to: '/mockups/rotator',        label: 'Rotator' },
  { to: '/mockups/safe-list',      label: 'Safe List' },
  { to: '/mockups/credits',        label: 'Credit Wallet' },
  { to: '/mockups/training',       label: 'Training Vault' },
  { to: '/mockups/lead-capture',   label: 'Lead Capture Templates' },
  { to: '/mockups/tools',          label: 'Tools / Services Hub' },
];

export default function MockupShell({ title, subtitle, children, dataTestId = 'mockup-shell' }) {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="mk-shell" data-testid={dataTestId}>
      {/* Top bar */}
      <header className="mk-topbar">
        <Link to="/mockups" className="mk-brand" aria-label="BBC Quick List">
          <span className="mk-brand-tiles" aria-hidden="true">
            <span>B</span><span>B</span><span>C</span>
          </span>
          <span className="mk-brand-name">
            Quick List
            <em>Builder Back-Office</em>
          </span>
        </Link>

        <span className="mk-demo-pill" data-testid="mockup-demo-pill">
          <span className="mk-demo-dot" /> DEMO — VISUAL CONCEPT
        </span>

        <button
          className="mk-nav-toggle"
          onClick={() => setNavOpen((v) => !v)}
          aria-label="Toggle navigation"
          data-testid="mockup-nav-toggle"
        >
          <span /><span /><span />
        </button>
      </header>

      <div className="mk-body">
        {/* Side nav */}
        <aside className={`mk-nav ${navOpen ? 'is-open' : ''}`} data-testid="mockup-nav">
          <ul>
            {NAV.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.to === '/mockups'}
                  className={({ isActive }) => (isActive ? 'is-active' : '')}
                  onClick={() => setNavOpen(false)}
                  data-testid={`mockup-nav-${item.to.replace('/mockups', '').replace('/', '') || 'overview'}`}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <p className="mk-nav-foot">
            Non-custodial member-to-member payments via NowPayments / TRON&nbsp;TRC-20.
          </p>
        </aside>

        {/* Main content */}
        <main className="mk-main">
          <div className="mk-page-head">
            <h1 data-testid="mockup-page-title">{title}</h1>
            {subtitle && <p>{subtitle}</p>}
          </div>
          {children}
          <footer className="mk-footer">
            <span>BBC Quick List · Builder Back-Office</span>
            <span>
              Non-custodial · Member-to-member · NowPayments / TRON TRC-20 · Admin never holds member funds.
            </span>
          </footer>
        </main>
      </div>
    </div>
  );
}
